<div class="bus-sector-container" #container>
  <div class="route" #bodycontainer>
    <div *ngFor="let sector of airValidationSector; index as i">
      <span *ngIf="isMobile; else desktopRoute">
        <p class="date">{{busDepartureDate(sector) | date:'EEEE, d MMM yyyy'|  dateFormat }}</p>
      </span>
      <ng-template #desktopRoute>
        <div class="collapsed-info-container" (click)="toggleTravelInfo(sector)">
          <div class="header">
            <span> {{busType(sector) | transloco}}</span>
            <i aria-hidden="true" class="icon-arrow-drop-up rotate-90"></i>
            <span class="date">{{ busDepartureDate(sector) | date: 'EEEE, dd MMMM' | dateFormat }}</span>
            <i aria-hidden="true" class="icon-arrow-drop-up right expander" [class.rotate-180]="!sector.isExpanded"> </i>
          </div>
          <ng-container *ngIf="!sector.isExpanded">
            <app-resume-sector
              [summaryProvider]="travelInfoProvider"
              [sector]="sector">
            </app-resume-sector>
          </ng-container>
        </div>
      </ng-template>

      <ng-container *ngIf="sector.isExpanded || isMobile">
        <ng-container *ngFor="let bus of sector.Flights; index as i">
          <app-bus-info
            [isMobile]="isMobile"
            [companyCode]="bus.AirlineCode"
            [opTerminalCode]="bus.OpAirlineCode"
            [number]="bus.Number"
            [departureDate]="bus.DepartureDate"
            [departureTerminal]="bus.DepartureAirport"
            [arrivalDate]="bus.ArrivalDate"
            [arrivalTerminal]="bus.ArrivalAirport"
            [bus]="bus.Equipment"
            [travelInfoProvider]="travelInfoProvider"
            [busClass]="busClass">
          </app-bus-info>
          <app-flight-segment-connection
            [hasScales]="hasScales"
            [provider]="provider"
            [isConnectionInDifferentAirport]="bus.IsConnectionInDifferentAirport"
            [isScaleElement]="isScaleElement(sector, i)"
            [numberOfStops]="bus.NumberOfStops"
            [totalDuration]="sector.TotalDuration"
            [technicalStopAirport]="bus.TechnicalStopAirport"
            [technicalStopTime]="bus.TechnicalStopTime"
            [flight]="busItem(sector, i)"
            [nextFlight]="nextBusItem(sector, i)">
          </app-flight-segment-connection>
        </ng-container>
      </ng-container>
      
    </div>
    <app-payment-detail
      *ngIf="isMobile"
      [passengerArrangement]="passengerArrangement"
      [price]="price"
      [isBuses]="true"
      [conversionRate]="conversionRate"
      [productReference]="productReference">
    </app-payment-detail>
  </div>
</div>